const ActionTypes = {
    CREDIT_CREATE_FAILURE: 'CREDIT_CREATE##FAILURE',
    CREDIT_CREATE_REQUEST: 'CREDIT_CREATE##REQUEST',
    CREDIT_CREATE_SUCCESS: 'CREDIT_CREATE##SUCCESS',
    CREDIT_DELETE_FAILURE: 'CREDIT_DELETE##FAILURE',
    CREDIT_DELETE_REQUEST: 'CREDIT_DELETE##REQUEST',
    CREDIT_DELETE_SUCCESS: 'CREDIT_DELETE##SUCCESS',
    CREDIT_ID_FETCH_FAILURE: 'CREDIT_ID_FETCH##FAILURE',
    CREDIT_ID_FETCH_REQUEST: 'CREDIT_ID_FETCH##REQUEST',
    CREDIT_ID_FETCH_SUCCESS: 'CREDIT_ID_FETCH##SUCCESS',
    CREDIT_TYPES_FETCH_FAILURE: 'CREDIT_TYPES_FETCH##FAILURE',
    CREDIT_TYPES_FETCH_REQUEST: 'CREDIT_TYPES_FETCH##REQUEST',
    CREDIT_TYPES_FETCH_SUCCESS: 'CREDIT_TYPES_FETCH##SUCCESS',
    CREDIT_UPDATE_FAILURE: 'CREDIT_UPDATE##FAILURE',
    CREDIT_UPDATE_REQUEST: 'CREDIT_UPDATE##REQUEST',
    CREDIT_UPDATE_SUCCESS: 'CREDIT_UPDATE##SUCCESS',
    CREDITS_FETCH_FAILURE: 'CREDITS_FETCH##FAILURE',
    CREDITS_FETCH_REQUEST: 'CREDITS_FETCH##REQUEST',
    CREDITS_FETCH_SUCCESS: 'CREDITS_FETCH##SUCCESS',
} as const

export default ActionTypes
